import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import "./JobDashboardCommissionBlock.scss";
import useTranslationJobDashboard from "../useTranslationJobDashboard.js";
import PageSubtitle from "../../common/widgets/PageSubtitle.js";
import useQueryJobGlobalMaxCommission from "../../jobs/view/useQueryJobGlobalMaxCommission.js";
import useQueryJobGlobalAverageCommission from "../../jobs/view/useQueryJobGlobalAverageCommission.js";
import JobSimilarJobsCommissionTip from "../../jobs/mutate/JobSimilarJobsCommissionTip.js";
import JobAverageCommissionTip from "../../jobs/mutate/JobAverageCommissionTip.js";
import JobMaxCommissionTip from "../../jobs/mutate/JobMaxCommissionTip.js";
import useQueryJobPublicSearch from "../../jobs/search/useQueryJobPublicSearch.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import TypeUtils from "../../../utils/TypeUtils.js";


function JobDashboardCommissionBlock(props) {
  const { job } = props;

  const { t, loading: tLoading } = useTranslationJobDashboard();
  useShowLoader(tLoading, "JobDashboardCommissionBlock");

  const commissionTitle = t("job-dashboard:job_dashboard_commission_label");

  // Get max commission
  const {
    data: jobGlobalMaxCommission,
    loading: jobGlobalMaxCommissionLoading,
    errors: jobGlobalMaxCommissionErrors,
  } = useQueryJobGlobalMaxCommission();

  // Get average commission
  const {
    data: jobGlobalAverageCommission,
    loading: jobGlobalAverageCommissionLoading,
    errors: jobGlobalAverageCommissionErrors,
  } = useQueryJobGlobalAverageCommission();

  // Get similar jobs
  // Memoize searchFilters to avoid re-rendering of components that use them on every render of this component
  const searchFilters = React.useMemo(() => ({
    queryText: TypeUtils.arrayRemoveNullOrEmpty([job.title, ...TypeUtils.ensureArray(job.technicalSkills)]).slice(0, 10),
    status: "PUBLISHED",
  }), [job.title, job.technicalSkills]);

  const {
    loading: similarJobsLoading,
    errors: similarJobsErrors,
    data: similarJobs,
  } = useQueryJobPublicSearch(10, searchFilters, "DATE_POSTED_DESC");

  return (
    <div className="JobDashboardCommissionBlock">
      <PageSubtitle colTitle={commissionTitle} />
      <Row>
        <Col className="commission-col">
          {job.commission > 0 && (
            <span className="commission-span">
              {t("job-dashboard:job_dashboard_job_details_commission_amounts", {
                amount: job.commission,
              })}
            </span>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <WaitForData
            loading={
              similarJobsLoading ||
              jobGlobalMaxCommissionLoading ||
              jobGlobalAverageCommissionLoading
            }
            errors={
              similarJobsErrors ||
              jobGlobalMaxCommissionErrors ||
              jobGlobalAverageCommissionErrors
            }
            onLoaded={() => (
              <>
                <Row>
                  <Col>
                    <JobSimilarJobsCommissionTip similarJobs={similarJobs} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <JobAverageCommissionTip
                      jobGlobalAverageCommission={jobGlobalAverageCommission}
                      similarJobs={similarJobs}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <JobMaxCommissionTip
                      jobGlobalMaxCommission={jobGlobalMaxCommission}
                      similarJobs={similarJobs}
                    />
                  </Col>
                </Row>
              </>
            )}
          />
        </Col>
      </Row>
    </div>
  );
}

export default JobDashboardCommissionBlock;
